import React, { Fragment } from 'react';
import { map, slice } from 'lodash';
import {
  Box,
  Set,
  SetDirection,
  Text,
  ProgressBarSize,
  ProgressBarDetail,
  ProgressBarDetailSpacing,
} from '@bechtel/gds';
import { WorkPackage } from '@bechtel/types';
import { WorkpackageItemCardStyled } from './styled';
import { useDateRange } from '~/hooks/use-date-range';
import { TextWithEllipsis } from '~/components/atoms/text-with-ellipsis';
import { t } from '@lingui/macro';

interface CommodityCountTagProps {
  commodityTypeName: string;
  totalQuantity: number;
  // numOnSite: number;
}
const CommodityCountTag: React.FC<CommodityCountTagProps> = ({ commodityTypeName, totalQuantity }) => {
  return (
    <Fragment>
      <Text size="250" color="grey.1000">
        {/* TODO: implement numOnSite value once DSC data is available */}
        {/* {commodityTypeName} : <Text color="grey.600">{numOnSite}/{totalQuantity}</Text> */}
        {commodityTypeName} : <Text color="grey.600">--/{totalQuantity}</Text>
      </Text>
    </Fragment>
  );
};

export const WorkPackageItemCard: React.FC<WorkPackage> = (workPackage) => {
  const [dateRangeLabel] = useDateRange(workPackage.startDate, workPackage.endDate);
  const percentageComplete = Math.round(workPackage.percentageComplete ?? 0);
  return (
    <WorkpackageItemCardStyled>
      <Box mb={{ sm: '300' }} data-testid={`workpackage-card`}>
        <TextWithEllipsis
          family="graphik"
          size="400"
          color={workPackage.numBlocks > 0 ? 'red.700' : 'grey.1000'}
          weight="600"
          transform="uppercase"
        >
          {workPackage.tag}
        </TextWithEllipsis>
      </Box>
      <Box mb={{ sm: '500' }} data-testid={`workpackage-card-date-range`}>
        <Text size="250" color="grey.600">
          {dateRangeLabel}
        </Text>
      </Box>
      <Set direction={SetDirection.ROW} style={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
        {map(slice(workPackage.materialsOnSite, 0, 3), (materialOnsite) => {
          return (
            <CommodityCountTag
              key={materialOnsite.commodityType.id}
              commodityTypeName={materialOnsite.commodityType.name}
              totalQuantity={materialOnsite.totalCommodities}
              // numOnSite={materialOnsite.numOnSite}
            />
          );
        })}
      </Set>

      <ProgressBarDetail
        size={ProgressBarSize.SMALL}
        currentValue={workPackage.earnedHours}
        totalValue={workPackage.totalEarnableHours}
        usePercentage={true}
        percentage={percentageComplete}
        fillPattern={!!workPackage.numBlocks}
        spacing={ProgressBarDetailSpacing.XSMALL}
        leftLabel={() => {
          return (
            <Text as="label" color="grey.600" size="200">
              {workPackage.numBlocks > 0 ? `${workPackage.numBlocks} ${t`Blocked Milestones`}` : t`In Progress`}
            </Text>
          );
        }}
        rightLabel={() => {
          return (
            <Text as="label" color="grey.600" size="200">
              {`${percentageComplete} ${t`% Complete`}`}
            </Text>
          );
        }}
        bgColor="white"
        borderColor="grey.300"
      />
    </WorkpackageItemCardStyled>
  );
};
